import React from 'react';
import PageTemplatePlanoAnual from '../../templates/PageTemplatePlanoAnual';
import StyledGlobal from '../../../../PlanoAnual2025.styled';
import { fetchStorageFile } from 'hooks/StoreFiles';
import PageThreeOnePlanoAnual from './PageThreeOnePlanoAnual';
import styled from 'styled-components';
import Colors from 'enums/Colors';
import PageThreeTwoPlanoAnual from './PageThreeTwoPlanoAnual';
import PageThreeThreePlanoAnual from './PageThreeThreePlanoAnual';
import PageThreeFourPlanoAnual from './PageThreeFourPlanoAnual';
import PageThreeFivePlanoAnual from './PageThreeFivePlanoAnual';
import PageThreeSixPlanoAnual from './PageThreeSixPlanoAnual';

export interface PageSessionThreePlanoAnualProps {
       ref3_1?: React.RefObject<HTMLDivElement>;
       ref3_2?: React.RefObject<HTMLDivElement>;
       ref3_3?: React.RefObject<HTMLDivElement>;
       ref3_4?: React.RefObject<HTMLDivElement>;
       ref3_5?: React.RefObject<HTMLDivElement>;
       ref3_6?: React.RefObject<HTMLDivElement>;
}

const Styled = {
    Content: styled.div`
        display: flex;
        flex-direction: column;
        gap: 20px;
        p {
            line-height: 24px;
            font-size: 18px;
        }

        h2 {
            font-size: 24px;
            font-weight: bold;
            color: ${Colors.Blue};
            text-transform: uppercase;
        }
    `,
};

const SessionAnaliseMunicipios: React.FC<PageSessionThreePlanoAnualProps> = ({
    ref3_1,
    ref3_2,
    ref3_3,
    ref3_4,
    ref3_5,
    ref3_6,
}) => {
    return (
        <>
            <PageTemplatePlanoAnual numberPage={11} stylesContent={{ marginRight: '80px' }}>
                <StyledGlobal.Title blue fontSize="32px">
                    3. ANÁLISE DOS MUNICÍPIOS
                </StyledGlobal.Title>
                <img src={fetchStorageFile('anexo_storage_files_11274100451054315359.webp_2025-11-19-1763571316996.webp')} alt="" />
            </PageTemplatePlanoAnual>

            <Styled.Content>
                {/* Page: 3.1 */}
                <div ref={ref3_1} id='sessionAnalise3_1'/>
                <PageThreeOnePlanoAnual />
                {/* Page: 3.2 */}
                <div ref={ref3_2} id='sessionAnalise3_2' />
                <PageThreeTwoPlanoAnual />
                {/* Page: 3.3 */}
                <div ref={ref3_3} id='sessionAnalise3_3' />
                <PageThreeThreePlanoAnual />
                {/* Page: 3.4 */}
                <div ref={ref3_4} id='sessionAnalise3_4' />    
                <PageThreeFourPlanoAnual />
                {/* Page: 3.5 */}
                <div ref={ref3_5} id='sessionAnalise3_5' />
                <PageThreeFivePlanoAnual />
                {/* Page: 3.6 */}
                <div ref={ref3_6} id='sessionAnalise3_6' />
                <PageThreeSixPlanoAnual />
            </Styled.Content>
        </>
    );
};

export default SessionAnaliseMunicipios;
